import './about.scss';

const About = ({ title, content }) => (
  <section className="about">
    {!title && (
      <div className="container not-home">
        <h2 className="section-title">Top Rated Moving Company</h2>
      </div>
    )}

    <div className="container">
      <div className="about__content">
        {title && <h2 className="section-title">{title}</h2>}

        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>

      <div className="about__media" />
    </div>
  </section>
);

export default About;
